import { makeStyles } from '@mui/styles'
import Colors from 'utils/Colors'

const styles = makeStyles(() => ({
  root: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    padding: '1rem',
    borderRadius: '5px',
    boxShadow: '1px 1px 3px 1px rgba(0,0,0,.25)',
    width: '100%',
  },
  actionsRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    width: 'fit-content',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    gap: '0.5rem',
  },
  
  confirmationContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    gap: '1rem',
  },
  
  confirmationContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    width: '100%',
    gap: '0.5rem',
    padding: '1rem',
    borderRadius: '5px',
    border: `1px solid ${Colors.gray}`,
    '& > p > span': {
      fontWeight: 600,
    },
  },
  
}))

export default styles
